import { Grid, Paper, Box, Typography, Button, TextField, MenuItem } from "@material-ui/core";
import React from "react";
//import { Link } from "react-router-dom";
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import axios from "axios";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);


function Home(props) {

  const [belong, setBelong] = React.useState(0);
  const [age, setAge] = React.useState(0);
  const [sex, setSex] = React.useState(0);

  const handleBelong = event => {
    setBelong(event.target.value);
  }

  const handleAge = event => {
    setAge(event.target.value);
  }

  const handleSex = event => {
    console.log(event.target.value);
    setSex(event.target.value);
  }

  const buttonPush = event => {
    if (!belong && !age) {
      alert("所属と学年をお答えください。");
      return;
    }
    // google form
    const GOOGLE_FORM_ACTION = "https://docs.google.com/forms/u/0/d/e/1FAIpQLScDMH_syBZVcKJT5kvcTWgsswPbSgrwAS9CI9os8unc3ONlOA/formResponse";
    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";

    const submitParams = new FormData();
    submitParams.append("entry.940165846", belong);
    submitParams.append("entry.1584816673", age);
    submitParams.append("entry.1050171546", sex);

    axios.post(CORS_PROXY + GOOGLE_FORM_ACTION, submitParams).then(() => {
      console.log("Submit sucess");
    }).catch((e) => {
      console.log(e);
    })

    // move health check
    props.history.push("/First");
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container alignItems="center" justify="center">
        <Grid item xs={11}>
          <Box p={2}>
            <Paper>
              <Box p={1}>
                <Typography variant="h4">近畿大学メンタルヘルスチェック</Typography>
                <Typography variant="body1">
                  アンケートに答えることで、あなたの心理状態を診断し、助言やリラックスにつながるコンテンツをオススメします。
                </Typography>

                <Box p={2}>
                  <Typography variant="body1">
                    メンタルチェックをする前に、事前アンケートに協力をお願いします。
                </Typography>
                  <Typography variant="body2">
                    本チェックリストに記載いただいた個人情報に付いては、管理責任者を定めて安全対策を積極的に実施します。また、頂いた個人情報とチェックリストの結果は分離させます。個人情報およびチェックリストの結果はプロジェクトの分析および報告以外には使用しません。個人情報の取り扱いに関するお問い合わせは下記窓口までご連絡ください。
                </Typography>
                  <Typography variant="caption">
                    TEL: 06-4307-3076(管理責任者: 長田)
                  </Typography>

                </Box>
                <Grid container alignItems="center" justify="center">
                  <Grid item>
                    <TextField style={{ "width": "30ch" }} className="test" required id="entry.940165846" variant="filled" label="所属(学部・教員・職員)" margin="normal" onChange={handleBelong} />
                  </Grid>
                </Grid>
                <Grid container alignItems="center" justify="center">
                  <Grid item>
                    <TextField style={{ "width": "30ch" }} className="test" required id="entry.1584816673" variant="filled" label="学年(教職員の場合はXX歳代)" margin="normal" onChange={handleAge} />
                  </Grid>
                </Grid>
                <Grid container alignItems="center" justify="center">
                  <Grid item>
                    <TextField style={{ "width": "30ch" }} className="test" id="entry.1050171546" label="性別" select value={sex} onChange={handleSex}>
                      <MenuItem value="男性">男性</MenuItem>
                      <MenuItem value="女性">女性</MenuItem>
                      <MenuItem value="その他">その他</MenuItem>
                      <MenuItem value="回答しない">回答しない</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
                <Grid container alignItems="center" justify="center">
                  <Grid item>
                    <Box p={2}>
                      <Button variant="contained" color="primary" size="large" onClick={() => { buttonPush() }}>メンタルチェックを行う</Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box p={1}>
                <Typography variant="caption">
                  協力: 総合理工学研究科エレクトロニクス系工学専攻
                </Typography>
                <br></br>
                <Typography variant="caption">
                  引用文献:<br></br>
                  1. 丹治光浩（2011）中学生・高校生・大学生のための自己理解ワーク　ナカニシヤ出版
                  <br></br>
                  2. Covid-19子どものサポートチームA（代表：秋冨慎司・冨永良喜） 心とからだのチェックリスト
                  <br></br>
                  <a href="http://traumaticstress.cocolog-nifty.com/ver02/2020/06/post-0f6b5a.html">
                    http://traumaticstress.cocolog-nifty.com/ver02/2020/06/post-0f6b5a.html
                       </a>
                </Typography>
              </Box>
            </Paper>
          </Box>
          <Typography variant="caption" style={{ "fontSize": "10px" }}>制作:　理工学部情報学科 計算知能研究室</Typography>
        </Grid>
      </Grid >
    </ThemeProvider >

  )
}
export default withRouter(Home);
